import { MetaData, SubscriptionsPage } from '@/components'
import {
  fetchAreaInfo,
  fetchAreaSubscriptions,
  getAreaInfoById,
} from '@/store/slices/stagesSlice/stagesSlice'
import { initializeStore } from '@/store'
import { NextPage } from 'next'

const NextSubscriptionsPage: NextPage<{
  areaId: string
  number: string | null
  stageId: string | null
}> = ({ areaId, number, stageId }) => {
  return (
    <>
      <MetaData />
      <SubscriptionsPage areaId={areaId} number={number} stageId={stageId} />
    </>
  )
}

NextSubscriptionsPage.getInitialProps = async ({ query }) => {
  const areaId: string = query.areaId as string
  const number: string | null = (query.number || null) as string | null
  const stageId: string | null = (query.stageId || null) as string | null

  const reduxStore = initializeStore()
  const { dispatch, getState } = reduxStore

  await dispatch(fetchAreaSubscriptions({ areaId }))

  const response = getAreaInfoById(getState(), areaId)
  if (!response.data) {
    await dispatch(fetchAreaInfo({ id: areaId }))
  }

  return {
    initialReduxState: reduxStore.getState(),
    areaId,
    number,
    stageId,
    headerLayout: 'back',
  }
}

export default NextSubscriptionsPage
